<template>
  <div class="view-submission">
    <div v-if="formData.logoUrl" class="form-logo text-center mb-3">
      <img :src="formData.logoUrl" alt="Company Logo" style="max-height: 60px; max-width: 180px; object-fit: contain;" />
    </div>
    <b-card class="mb-4 header-card">
      <h4 class="mb-1">Your Submission for: {{ formData.title || 'Untitled Form' }}</h4>
      <p class="text-muted mb-0">Submitted on: <span v-if="myResponse">{{ formatDate(myResponse.submittedAt) }}</span></p>
    </b-card>
    <b-card v-if="myResponse">
      <div v-for="question in formData.questions" :key="question.id" class="mb-4">
        <div v-if="question.type !== 'header'">
          <div class="font-weight-bold mb-1">{{ question.text }}</div>
          <div class="mb-1">
            <span v-if="Array.isArray(myResponse.answers[question.id])">
              {{ myResponse.answers[question.id].join(', ') }}
            </span>
            <span v-else-if="typeof myResponse.answers[question.id] === 'object' && myResponse.answers[question.id] !== null">
              {{ myResponse.answers[question.id].answer }}
              <span v-if="myResponse.answers[question.id].reason">(Reason: {{ myResponse.answers[question.id].reason }})</span>
            </span>
            <span v-else>
              {{ myResponse.answers[question.id] || 'No answer' }}
            </span>
            <div v-if="question.type === 'radio' && myResponse.answers[question.id + '_conditional']" class="text-muted small mt-1">
              Conditional: {{ myResponse.answers[question.id + '_conditional'] }}
            </div>
          </div>
        </div>
        <div v-else class="header-preview">
          <component :is="question.headerStyle || 'h2'" :class="`text-${question.headerColor || 'primary'} mb-2`">
            {{ question.text || 'Header Text' }}
          </component>
        </div>
      </div>
    </b-card>
    <div v-else class="text-center py-5">
      <feather-icon icon="FileTextIcon" size="48" class="text-muted mb-3" />
      <h5 class="text-muted">No submission found</h5>
      <p class="text-muted">You have not submitted this form yet.</p>
    </div>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import FormsService from '@/services/forms-service'

export default {
  name: 'ViewSubmission',
  components: { BCard, FeatherIcon },
  data() {
    return {
      formData: {},
      myResponse: null,
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getCurrentUserId() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      return userData.id || 'anonymous'
    }
  },
  async mounted() {
    try {
      // Load form data
      const formResponse = await FormsService.getFormById(this.$route.params.id)
      if (formResponse.success && formResponse.data) {
        this.formData = formResponse.data
      } else {
        throw new Error('Form not found')
      }
      
      // Load only the current user's response
      const responsesResponse = await FormsService.getFormResponses(this.$route.params.id)
      if (responsesResponse.success && responsesResponse.data) {
        const userId = this.getCurrentUserId()
        this.myResponse = responsesResponse.data.find(r => String(r.formId) === String(this.$route.params.id) && r.userId === userId)
      } else {
        this.myResponse = null
      }
    } catch (error) {
      this.$bvToast.toast('Error loading submission', {
        title: 'Error',
        variant: 'danger',
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
.view-submission {
  max-width: 700px;
  margin: 0 auto;
  padding: 16px;
}
.form-logo {
  margin-bottom: 10px;
}
.header-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 16px;
  margin-bottom: 24px;
}
.header-card h4, .header-card p {
  color: white;
}
.b-card {
  border-radius: 12px;
  margin-bottom: 18px;
}
.header-preview {
  text-align: center;
  padding: 20px 0;
}
</style> 